import { Box, ButtonBase } from "@mui/material";
import { useState, useEffect } from "react";
import 'aos/dist/aos.css';

const Partners = ({ PartnerList = [] }) => {
  return (
    <Box
      className="partnerBackground"
      sx={{
        width: "100%",
        height: "auto",
        overflow: "hidden",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        padding: { xs: "20px", sm: "40px" },
      }}
    >
      <h1 
          className='primary-header'
          style={{color: '#3b76b2', textAlign: 'center'}}
          data-aos="fade-down"
          data-aos-delay="200"
        >
          OUR PARTNERS
      </h1>
      <Box sx={{ width: "100%", maxWidth: "1200px" }}>
        {PartnerList.length > 0 && (
          <Box
            sx={{
              display: "flex",
              flexDirection: "row",
              gap: 2,
              alignItems: "center",
              justifyContent: PartnerList.length > 5 ? "flex-start" : "space-evenly",
              height: "100px",
              overflow: PartnerList.length > 5 ? "hidden" : "visible",
              position: "relative",
            }}
          >
            {PartnerList.length > 5 ? (
              <Box
                sx={{
                  display: "flex",
                  flexDirection: "row",
                  gap: 2,
                  animation: "scroll 20s linear infinite",
                  whiteSpace: "nowrap",
                  "&:hover": {
                    animationPlayState: "paused",
                  },
                }}
              >
                {[...PartnerList, ...PartnerList].map((partner, index) => (
                  <ButtonBase href={`${partner.web_link ? partner.web_link: '#' }`} key={index}>
                    <Box
                      key={`${partner.id}`}
                      width={'150px'}
                      height={'50px'}
                      display={'flex'}
                      flexDirection={'column'}
                      alignItems={'center'}
                      justifyContent={'center'}
                      padding={'.3rem'}
                      borderRadius={1}
                      sx={{ backgroundColor: '#fff' }}
                    >
                      
                        <img
                          src={`https://mindsinaction.com.na/assets/media/pictures/${partner.image}`}
                          alt={partner.name || "partner"}
                          style={{ width: "100%", height: '100%', objectFit: "contain" }}
                        />
                      
                    </Box>
                  </ButtonBase>
                ))}
              </Box>
            ) : (
              PartnerList.map(partner => (
                <Box
                  key={partner.id}
                  width={'200px'}
                  height={'80px'}
                  display={'flex'}
                  flexDirection={'column'}
                  alignItems={'center'}
                  justifyContent={'center'}
                  padding={'.3rem'}
                  borderRadius={1}
                  sx={{ backgroundColor: '#fff' }}
                >
                  <img
                    src={`https://mindsinaction.com.na/assets/media/pictures/${partner.image}`}
                    alt={partner.name || "partner"}
                    style={{ width: "100%", height: '100%', objectFit: "contain" }}
                  />
                </Box>
              ))
            )}
          </Box>
        )}
      </Box>
      <style>{`
        @keyframes scroll {
          0% {
            transform: translateX(0);
          }
          100% {
            transform: translateX(-50%);
          }
        }
      `}</style>
    </Box>
  );
};

export default Partners;